function Footer() {
    return (
      <footer>
        <p>&copy; {new Date().getFullYear()} Chronicles of Chaos. All rights reserved.</p>
      </footer>
    );
  }
  
  export default Footer;
